export interface LockoutCopy {
  /** "15 minutes" */
  duration: string;
  /** "4:27 PM IST" */
  until: string;
}

/** Turns "locked for N more seconds" into the wording the locked-out sign-in screen uses (Figma A01.1 · Locked). */
export function lockoutCopy(retryAfterSeconds: number, now: number = Date.now(), locale = 'en-IN'): LockoutCopy {
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60));
  const until = new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(
    new Date(now + retryAfterSeconds * 1000),
  );
  return { duration: `${minutes} minute${minutes === 1 ? '' : 's'}`, until };
}
